import React from 'react';

interface ILayoutLogin {
    children?: React.ReactNode
}

const LayoutLogin = ({
    children
}: ILayoutLogin) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 min-h-screen max-h-screen overflow-y-auto">
            <div className="p-3">
                {children}
            </div>
            <div className='hidden md:block'>
                <div className="sticky top-0 bottom-0 h-screen p-3">
                    <img
                        src="/assets/admin/signin-color-img.svg"
                        alt="Login Illustration"
                        className="w-full h-full object-cover object-top"
                    />
                </div>
            </div>
        </div>
    );
}

export default LayoutLogin;